export const buttonHAlignToKonva = (value: unknown): string => {
  if (typeof value !== 'string') {
    return 'center';
  }

  switch (value.toUpperCase()) {
    case 'LEFT':
      return 'left';
    case 'RIGHT':
      return 'right';
    default:
      return 'center';
  }
};
